const { fetcher, endpoints } = require('src/utils/axios');
const { default: useSWR } = require('swr');

const useCurrenciesLOV = () =>
  useSWR(endpoints.common.getCurrencies, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

export default useCurrenciesLOV;
